// extracted by mini-css-extract-plugin
export default {"contentBox":"About_contentBox__98rUx","aboutWrapper":"About_aboutWrapper__eSPZq","flex":"About_flex__Cadcj","socialLinks":"About_socialLinks__hRwNH"};